export const messageError = new Map<number, string>([
  [1, 'Invalid public key'],
  [2, 'Account not found'],
  [3, 'Invalid issuing public key'],
  [4, 'Invalid distribution public key'],
  [5, 'Issuing account not found'],
  [6, 'Distribution account not found'],
  [7, 'Invalid envelope XDR'],
  [8, 'Distribution has no trustline'],
  [9, 'Distribution has no trustline limit'],
  [10, 'Invalid recipient public key'],
  [11, 'Recipient account not found'],
  [12, "Issuing can't be the target"],
  [13, 'No target selected'],
  [14, 'Target has no trustline'],
  [15, 'Missing target fields'],
  [16, 'Issuing must have auth revocable flag'],
  [17, 'Invalid Claimable ID'],
  [18, 'Issuing must have Auth Clawback flag'],
  [19, 'Invalid Network'],
  [20, 'TOML Not found'],
  [21, 'Invalid signer key'],
])